import React, { useEffect } from 'react';
import { Alert, Form, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import type { KrybotAgent } from '../../../types/krybot';
import { JsonSchemaEditor } from './JsonSchemaEditor';

interface AgentCapabilitiesTabProps {
  agent: KrybotAgent | null;
  agentData: Partial<KrybotAgent>;
  isCreating: boolean;
  onDataChange: (updates: Partial<KrybotAgent>) => void;
  onSave: () => void;
  loading: boolean;
}

export const AgentCapabilitiesTab: React.FC<AgentCapabilitiesTabProps> = ({
  agent,
  agentData,
  isCreating,
  onDataChange,
  onSave,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      capabilities: agentData.capabilities || {},
    });
  }, [agentData.capabilities, form]);

  const handleChange = (value: Record<string, unknown> | null) => {
    onDataChange({ capabilities: value || {} });
  };

  const validateJson = (_: unknown, value: Record<string, unknown> | null) => {
    if (!value) {
      return Promise.resolve();
    }
    return Promise.resolve();
  };

  return (
    <div className="agent-capabilities-tab">
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0 }}>Capabilities</h3>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={onSave}
          loading={loading}
        >
          Save Changes
        </Button>
      </div>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="Boolean capability flags"
        description="Use visual mode for boolean feature flags. Skill bind fields (skill_bundle, bridge_krybot_agent_id, include_skill_file_in_prompt) belong on the Skills & resources tab. Code mode can still edit the full capabilities JSON."
      />
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          capabilities: agentData.capabilities || {},
        }}
      >
        <Form.Item
          name="capabilities"
          rules={[{ validator: validateJson }]}
          help="Define what actions this agent can perform. Use the visual editor or switch to code mode."
        >
          <JsonSchemaEditor
            fieldType="capabilities"
            agentType={agentData.agent_type}
            disabled={loading}
            value={agentData.capabilities}
            onChange={handleChange}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

